import { Box, Grid, Tab, Tabs } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { SectionServices } from '../Section/SectionServices';
import Swal from 'sweetalert2';

const normalizeTitle = (value) => (value || '').toString().trim().toLowerCase();
const normalizeKey = (value) => normalizeTitle(value).replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
const isHiddenItemSection = (section) => {
    const title = normalizeTitle(section?.title);
    const key = normalizeKey(section?.title);

    return key === 'book-again'
        || key === 'category'
        || key === 'app-banner'

        || key === 'categories'
        || title.includes('cudel footer')
        || key.includes('cudel-footer');
};

const SectionTabs = ({selectedSection, setSelectedSection, initialSectionId, pageType = 'section'}) => {
    const [selectedTab, setSelectedTab] = useState(0);
    const handleTabChange = (event, newValue) => {
        setSelectedTab(newValue);
        setSelectedSection(
            sectionList[newValue]
        );
    };

    const [sectionList, setSectionList] = useState([]);
    const getPageType = (section) => section?.displayOptions?.pageType || section?.pageType || 'section';
    const fetchSectionList = async () => {
        try{
            const response = await SectionServices.fetchSectionList({
                pageType,
                sortBy: 'position',
                sortType: 'ASC'
            });
            if(response.success == '1'){
                const allSections = response.data.list || [];
                const sections = allSections
                    .filter(section => getPageType(section) === pageType && (pageType !== 'section' || !isHiddenItemSection(section)))
                    .sort((a, b) => Number(a?.position || 0) - Number(b?.position || 0));
                setSectionList(sections);
                const initialIndex = initialSectionId ? sections.findIndex(section => section.id === parseInt(initialSectionId)) : 0;
                const nextIndex = initialIndex >= 0 ? initialIndex : 0;
                setSelectedTab(nextIndex);
                setSelectedSection(sections[nextIndex] || null);
            }else if(response.success == '0'){
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: response.message || 'Failed to fetch sections',
                });
                setSectionList([]);
            }

        } catch(error){
            console.log("error", error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Failed to fetch section details',
            });
        }
    }
    useEffect(()=>{
        fetchSectionList();
    },[initialSectionId, pageType])
  return (
    <Box sx={{ marginTop: '.5%' }}>
        <Tabs
            value={sectionList.length ? selectedTab : false}
            onChange={handleTabChange}
            indicatorColor="primary"
            textColor="primary"
            orientation="vertical" // Set the orientation to 'vertical'
            variant="scrollable" // Use 'scrollable' variant for longer lists
            scrollButtons="auto"
            sx={{ backgroundColor: "#fff" }}
            align="left"
        >
            {sectionList?.map((section, index) => (
                <Tab key={section.id || index} label={section.title}
                    sx={{
                        borderBottom: '1px solid lightGray',
                        fontSize: '.8rem',
                        bgcolor: 'transparent',
                        // color: section?.isActive ? '#fff' : 'text.primary',
                        // textTransform:'capitalize',
                    }}
                />
            ))}
        </Tabs>
    </Box>
  )
}

export default SectionTabs
